
<div class="min-w-128 min-h-140">
    <div class="px-4 py-2 border-b h-16 flex justify-between items-center">
    
        <div class="text-black flex items-center justify-center h-8 w-8" >
            <mat-icon class="text-transparent" [svgIcon]="'heroicons_solid:chevron-left'"></mat-icon>
        </div>
    
        <h2 class="text-xl font-bold leading-none flex items-center">
            {{ "campaign.contact_us" | transloco }}
        </h2>
    
        <ac-button type="icon" color="primary" mat-dialog-close>
            <mat-icon [svgIcon]="'heroicons_outline:x-mark'" class="text-black"></mat-icon>
        </ac-button>
    </div>
    
    
    <div class="p-4 flex flex-col gap-4 overflow-y-auto" style="max-height: 80vh">
        <div class="flex flex-col gap-4">
            <div class="grid grid-cols-1 gap-4">
                <text-input-form-field [control]="form.get('email')" [label]="'campaign.email' | transloco" class="md:col-span-8"
                [isDisabled]="true"></text-input-form-field>
                <text-input-form-field [control]="form.get('subject')" [label]="'campaign.subject' | transloco"
                class="md:col-span-8"></text-input-form-field>
                <mat-form-field class="md:col-span-8">
                    <mat-label>{{ "campaign.message" | transloco }}</mat-label>
                    <textarea [formControl]="form.get('message')" matInput></textarea>
                </mat-form-field>
            </div>
        </div>
    </div>
</div>


<div class="px-4 py-4 border-t flex justify-between content-between items-center">
    
    <ac-button type="text"  mat-dialog-close>
        {{ "campaign.cancel" | transloco }}
    </ac-button>
   
    <ac-button 
        [disabled]="form.invalid" 
        [loading]="isLoading" 
        (click)="save()" 
        color="primary"
        
    >
            {{ "campaign.send" | transloco }}
    </ac-button>
</div>